import { render, staticRenderFns } from "./personnel_bar.vue?vue&type=template&id=61165c2b&"
import script from "./personnel_bar.vue?vue&type=script&lang=js&"
export * from "./personnel_bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports